
import Vue from 'vue';
import {mapState, mapGetters} from 'vuex';
import axios from 'axios';
import EventService from '../services/EventService';
import DebugFeature from '../services/DebugFeature';
import type {GroupRes, YearInfo} from '../services/types';
import store, {
  ConfSortByValue, // TODO (ohtsuchi) 2025年以降 コードを削除
  type ScopeKey,
} from '../store';
import moment from 'moment';
import ScopeSelector from '../components/ScopeSelector.vue';
import {GetScopeFromKey} from '../store/index';
import {expiredConfSortBy} from '@/services/Conf'; // TODO (ohtsuchi) 2025年以降 コードを削除
import type {User} from 'firebase/auth';

type InfoContext = {
  user: string;
  phone: string;
  email: string;
  summary: string;
  detail: string;
};

type UserAdd = {
  familyName: string;
  firstName: string;
  jfamilyName: string;
  jfirstName: string;
};

type UserListItem = {
  name: string;
  id: string;
  furigana: string;
  isRemoved: boolean;
  isNotDisplay: boolean;
};

type Data = {
  company: string;
  year: number;
  targetYear: number;
  targetYears: {d: YearInfo; y: number}[];
  infoSnackMessageColor: string;
  infoSnackMessage: string;
  infoVerify: boolean;
  infoSnack: boolean;
  infoContext: InfoContext;
  infoDialog: boolean;
  isNew: boolean;
  isGroup: boolean;
  companyList: Array<GroupRes>;
  val: string;
  id: number;
  drawer: boolean;
  model: Array<1 | 2>;
  userAddDialog: boolean;
  userRemoveDialog: boolean;
  userRemoveFlage: boolean;
  userRemoveSelectedOption: UserRemoveOptionValue;
  userRemoveOptions: userRemoveOption[];
  userMoveDialog: boolean;
  userMoveFlage: boolean;
  toBranchOffice: string;
  traineeID: string;
  removeUsers: Array<string>;
  userAdd: UserAdd;
  snackbar: boolean;
  snackbarMessage: string;
  snackbarColor: string;
  snackbarTimeout: number;
  verify: boolean;
  UserListItems: Array<UserListItem>;
  traineeName: string;
  targetBranchOfficeName: string;
  managementPdfManualURL: string;
  managementExcelManualURL: string;
  operationSystemManualURL: string;
  operationVRManualURL: string;
};

type Method = {
  selectedToTrainee(val: string): void;
  selectedToBranchOffice(val: string): void;
  nameRule(val: string): void;
  init(token: string): Promise<void>;
  displayCompnayName(l: Array<GroupRes> | null): Array<string>;
  userRemoveDialogInit(): Promise<void>;
  userMoveDialogInit(): Promise<void>;
  send(): Promise<void>;
  changeCompany(): Promise<void>;
  usermove(): Promise<void>;
  userremove(): Promise<void>;
  userRemoveOptionChange(value: UserRemoveOptionValue): void;
  useradd(): Promise<void>;
  logout(): Promise<void>;
  jump(jumpPath: string): void;
  info(): void;
  isNoSubGroup(year: number): boolean;
  getManualURL(
    token: string,
    prefix: string,
    scope: string,
    fileType: string
  ): Promise<string>;
};

type Computed = {
  getProcedurePrefix: string;
  isMove: boolean;
  branchOfficeList: (string | undefined)[];
  version: string;
  colorFromScope: string;
  name: void;
  currentMode: string;
  histList: HistoryItem;
  menuList: Item[];
  menuListForNoSubGroup: Item[];
  isNoSubGroupTargetYear: boolean;
  traineeLabel: string;
  getMaxBranchOfficeCurrentYear: string;
  getBranchOfficeScopes: string[];
  selectedBranchOffice: boolean;
  isAllRemoveUsersSelected: boolean;
  isUserRemoveSelectedOptionDelete: boolean;
  isUserRemoveSelectedOptionChangeDisplay: boolean;
  isUserRemoveSelectedOptionRestore: boolean;
  isBranchOfficeView: boolean;
  user: User | undefined;
  newsCount: number;
  scope: Array<string>;
  currentScope: ScopeKey;
  current: string;
  noSubGroupStartYear: number;
  isLogin: boolean;
};

type SubItem = {
  icon: string;
  text: string;
  jumpPath: string;
};

type Item = {
  icon: string;
  title: string;
  active: boolean;
  items: Array<SubItem>;
  hiyariitems: Array<SubItem>;
};

type HistoryItem = {
  icon: string;
  title: string;
  active: boolean;
  items: Array<SubItem>;
};

// const genNaviItem = (month: number): SubItem => {
//   return {
//     icon: 'mdi-circle-medium',
//     text: `${month}月`,
//     jumpPath: `/month-teaching/${month}`,
//   };
// };

// const naviItems = [
//   {
//     icon: '360',
//     text: '進捗まとめ',
//     jumpPath: '/colum',
//   },
// ];

const hitems = [
  {
    icon: 'add',
    text: '新規作成',
    jumpPath: '/audithistoryNew',
  },
  {
    icon: 'view_module',
    text: '履歴リスト',
    jumpPath: '/audithistoryData',
  },
];

// const ditems = [
//   {
//     icon: 'movie',
//     text: 'デモ動画',
//     jumpPath: '/demo-video',
//   },
// ];

const historyList: HistoryItem = {
  icon: 'event',
  title: '受講/監査記録',
  active: false,
  items: hitems,
};

const yearTragetItems = (year: number, is2D = false, isHiyari = false) => {
  const base = [
    {
      icon: 'mdi-virtual-reality',
      text: '研修進捗状況',
      jumpPath: `/colum?year=${year}&main=${!isHiyari}`,
    },
  ];

  if (!isHiyari) {
    base.push({
      icon: 'mdi-notebook-outline',
      text: '年次計画表',
      jumpPath: `/year/${year}`,
    });
  }
  base.push({
    icon: 'mdi-file-table-box-outline',
    text: '星取表',
    jumpPath: `/chart/top?year=${year}&main=${!isHiyari}`,
  });
  if (is2D) {
    base.push({
      icon: 'mdi-movie',
      text: '2D動画研修',
      jumpPath: `/2d?year=${year}&main=${!isHiyari}`,
    });
  }
  return base;
};

const createTargetYearMenue = (year: number, targetYear: number) => {
  return {
    icon: 'mdi-format-list-bulleted',
    title: `${year}年度`,
    active: year == targetYear,
    items: yearTragetItems(year, year >= targetYear, false),
    hiyariitems: yearTragetItems(year, year >= targetYear, true),
  };
};

enum UserRemoveOptionValue {
  Default = 0,
  ChangeDisplay = 1,
  Restore = 2,
}

type userRemoveOption = {
  text: string;
  value: UserRemoveOptionValue;
};

type Manual = {
  url: string;
};

// const demoList = {
//   icon: 'video_library',
//   title: '動画',
//   active: false,
//   items: ditems,
// };

const apiClient = axios.create({
  baseURL: EventService.ProtoURL(),
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(config => {
  const companyID = store.state.current;
  if (companyID !== '') {
    config.headers['x-company-id'] = companyID;
  }
  return config;
});

type VForm = Vue & {validate: () => boolean};

export default Vue.extend<Data, Method, Computed>({
  components: {
    ScopeSelector,
  },
  name: 'app-bar',
  async created() {
    console.log('created');
    try {
      // リロードされたとき
      const user = this.$store.state.user;
      if (user) {
        const token = await user.getIdToken();
        this.$store.commit('SET_USER_INFO', user.displayName);
        await this.init(token as string);
      }
    } catch (err) {
      console.log(err);
    }
  },

  methods: {
    selectedToTrainee(val: string) {
      this.traineeID = val;
    },
    selectedToBranchOffice(val: string) {
      const tmp = this.companyList.find(
        branchOffice =>
          branchOffice.companyJName === val || branchOffice.companyName === val
      );
      if (tmp) {
        this.toBranchOffice = tmp.companyID;
      }
    },
    nameRule(val: string) {
      return !!val || '名前を入力してください';
    },
    async init(token: string): Promise<void> {
      this.drawer = this.$vuetify.breakpoint.lg;
      var now = false;

      try {
        const {data} = await EventService.getGroup(token);
        this.companyList = data;
        if (data && data?.length > 0) {
          now = true;
        }
      } catch (err) {
        this.companyList = [];
        now = false;
      } finally {
        if (now != this.isGroup) {
          this.isGroup = now;
          store.commit('SET_IS_GROUP', this.isGroup);
        }
      }
      try {
        const range = (start: number, end: number) =>
          [...Array(end + 1).keys()].slice(start);
        const now = moment();
        // FIXME(Tukky): yearsの配列には DisplayDateの対象となる年度を入れるべき
        // 正しくは now.add(1, 'M').year() となる
        // ただし DisplayDateはユビキタス言語で定義されているので server側で計算することも考慮する
        var years = range(2020, now.year());
        if (DebugFeature.FeatureYear2023()) {
          years = range(2020, 2023);
        }
        const datas = await Promise.all(
          await years.map(async year => {
            const {data} = await EventService.getYearInfo(token, year);
            return {d: data, y: year};
          })
        );
        const targetYears = datas.filter(data => {
          const m = moment(data.d.start);
          const target = moment([m.year(), m.month()]).subtract(1, 'months');
          if (DebugFeature.FeatureYear2023()) {
            return true;
          } else {
            return now.isAfter(target);
          }
        });
        this.targetYears = targetYears;
        targetYears
          .sort((a, b): number => {
            if (a.y > b.y) {
              return 1;
            } else if (a.y < b.y) {
              return -1;
            } else {
              return 0;
            }
          })
          .forEach(v => {
            const s = moment(v.d.start, 'YYYY-MM-01');
            // ---sfsd(2021)-----sfsd(2022)--Now--sfsd(2023)---->
            // ソート済みの年度を利用して 2022年度を targetYearとする
            // FIXME(tukky): server の SystemYearDate.CurrentYearの値をそのまま利用する用にする
            if (DebugFeature.FeatureYear2023()) {
              this.targetYear = 2023;
            } else {
              if (now.isAfter(s)) {
                this.targetYear = v.y;
              }
            }
          });
      } catch (err) {
        console.log(err);
      }

      // TODO (ohtsuchi) 2025年以降 コードを削除 --- ここから
      try {
        const config = {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
        let confSortByExists = false;
        if (this.isGroup) {
          ({
            data: {exists: confSortByExists},
          } = await apiClient.get(`/groups/conf/sortBy/?target=all`, config));
        } else {
          ({
            data: {exists: confSortByExists},
          } = await EventService.existsConfSortBy(token));
        }
        if (confSortByExists) {
          store.commit('SET_SORT_BY', ConfSortByValue.Changed);
          // 仮にコードを削除するのを忘れていても、2025年度以降は DB Cleanup するように制御
          // ただし 統括アカウントログイン時 のみ
          if (this.isGroup && expiredConfSortBy()) {
            // CHANGED: (ohtsuchi) !101 で 2025-01-01 基準 -> 2025年度開始 基準 に仕様変更しようとしたが リリース前のテストが不可になったので 掃除機能 自体を無効化する
            // await apiClient.post(
            //   `/groups/conf/sortBy/delete/?target=all`,
            //   {},
            //   config
            // );
            // store.commit('CLEAR_SORT_BY');
          }
        }
      } catch (err) {
        console.log(err);
      }
      // TODO (ohtsuchi) 2025年以降 コードを削除 --- ここまで

      /*
      if (
        this.$route.query['year'] == null ||
        this.$route.query['year'] == ''
      ) {
        */

      try {
        await this.$store.dispatch('scope');
      } catch (err) {
        console.log(err);
      }

      if (this.isGroup && !this.selectedBranchOffice) {
        this.$router.push({
          name: 'Dashboard',
          query: {
            maxYear: `${this.getMaxBranchOfficeCurrentYear}`,
            scopes: `${this.getBranchOfficeScopes.join(',')}`,
          },
        });
      } else {
        if (!this.isNoSubGroupTargetYear) {
          this.$router.push({
            path: `/colum/?year=${this.targetYear}&main=true`,
            query: {_t: String(Date.now())},
          });
        } else {
          this.$router.push({
            path: `/colum/?year=${this.targetYear}&main=false`,
            query: {_t: String(Date.now())},
          });
        }
      }
      /*
      }
      */
      try {
        this.$store.dispatch('news');
        this.isNew = true;
      } catch {
        this.isNew = false;
      }

      const scope = GetScopeFromKey(this.currentScope);
      this.managementPdfManualURL = await this.getManualURL(
        token,
        'Procedure',
        scope,
        'pdf'
      );
      this.managementExcelManualURL = await this.getManualURL(
        token,
        'Procedure',
        scope,
        'excel'
      );
      this.operationSystemManualURL = await this.getManualURL(
        token,
        'system-manual',
        scope,
        'pdf'
      );
      this.operationVRManualURL = await this.getManualURL(
        token,
        'VR-manual',
        scope,
        'pdf'
      );
    },
    displayCompnayName(l: Array<GroupRes> | null): Array<string> {
      if (l) {
        return l.map(val =>
          val.companyJName ? val.companyJName : val.companyName
        );
      }
      return [];
    },
    async userRemoveDialogInit(): Promise<void> {
      const token = await this.user?.getIdToken();
      try {
        this.UserListItems.length = 0;
        const {data} = await apiClient.get<Array<UserListItem>>('/userctls/', {
          headers: {Authorization: `Bearer ${token}`},
        });
        this.UserListItems = data.filter((user: UserListItem) => {
          return !user.isRemoved;
        });
        // リストボックスの初期化
        this.userRemoveOptions = [];
        this.userRemoveOptions.push({
          text: '削除して「 氏名+(退職済み) 」として表示する',
          value: UserRemoveOptionValue.Default,
        });
        const removedDisplayCnt: number = data.filter((user: UserListItem) => {
          return user.isRemoved && !user.isNotDisplay;
        }).length;
        if (removedDisplayCnt > 0) {
          this.userRemoveOptions.push({
            text: '「 氏名+(退職済み) 」→ 非表示 に変更 (完全に削除)',
            value: UserRemoveOptionValue.ChangeDisplay,
          });
          this.userRemoveOptions.push({
            text: '「 氏名+(退職済み) 」→ 削除前に戻す',
            value: UserRemoveOptionValue.Restore,
          });
        }
      } catch (err) {
        console.log(err);
      }
      this.userRemoveDialog = true;
      this.userRemoveSelectedOption = UserRemoveOptionValue.Default;
    },
    async userMoveDialogInit(): Promise<void> {
      this.toBranchOffice = '';
      this.traineeID = '';
      this.traineeName = '';
      this.targetBranchOfficeName = '';
      this.userMoveFlage = false;
      const token = await this.user?.getIdToken();
      try {
        this.UserListItems.length = 0;
        const {data} = await apiClient.get<Array<UserListItem>>('/userctls/', {
          headers: {Authorization: `Bearer ${token}`},
        });
        this.UserListItems = data.filter((user: UserListItem) => {
          return !user.isRemoved;
        });
      } catch (err) {
        console.log(err);
      }
      this.userMoveDialog = true;
    },
    async send(): Promise<void> {
      (this.$refs.infoForm as VForm).validate();
      console.log(this.infoContext);
      const token = await this.user?.getIdToken();
      if (this.infoVerify) {
        try {
          await apiClient.post('/inquiry/', this.infoContext, {
            headers: {Authorization: `Bearer ${token}`},
          });
          this.infoSnackMessage = '問い合わせの送信を完了しました';
          this.infoSnackMessageColor = 'success';
        } catch (err) {
          console.log(err);
          this.infoSnackMessage = '問い合わせ中にエラーが発生しました';
          this.infoSnackMessageColor = 'error';
        } finally {
          this.infoSnack = true;
          this.infoDialog = false;
        }
      }
    },
    async changeCompany(): Promise<void> {
      console.log(this.val);
      const fil = this.companyList.filter(item => {
        return item.companyName === this.val || item?.companyJName === this.val;
      });
      const token = await this.user?.getIdToken();
      console.log(fil);
      if (fil.length > 0) {
        store.commit('SET_CURRENT', fil[0].companyID);
        store.commit(
          'SET_CURRENT_NAME',
          fil[0]?.companyJName || fil[0].companyName
        );
        store.commit(
          'SET_SAME_GROUP_BRANCH_OFFICE_LIST',
          this.companyList.filter(item => {
            return (
              item.companyID !== fil[0].companyID &&
              item.scope === fil[0].scope &&
              item.fiscalStartMonthDate === fil[0].fiscalStartMonthDate
            );
          })
        );
        await this.init(token);
      }
      // このタイミング userが切り替わるので watch user が有効になり画面遷移が発生する
    },
    async usermove(): Promise<void> {
      console.log('user move');
      this.userMoveDialog = false;
      const token = await this.user?.getIdToken();
      const param = {
        from: this.current,
        to: this.toBranchOffice,
        trainee: this.traineeID,
      };
      try {
        console.log(param);
        await apiClient.post('/groups/userctls/move/?target=all', param, {
          headers: {Authorization: `Bearer ${token}`},
        });
        this.snackbarMessage = `${this.traineeLabel}の移動に成功しました`;
        this.snackbarColor = 'success';
        this.snackbarTimeout = 3000;
        this.snackbar = true;
      } catch (err) {
        this.snackbarMessage = `${this.traineeLabel}の移動に失敗しました`;
        this.snackbarColor = '#F44336';
        this.snackbarTimeout = 3000;
        this.snackbar = true;
        console.log(err);
      }
    },
    async userremove(): Promise<void> {
      console.log('user remove');
      this.userRemoveFlage = false;
      this.userRemoveDialog = false;
      const token = await this.user?.getIdToken();
      const param = {
        userlist: this.removeUsers,
        isNotDisplay: this.isUserRemoveSelectedOptionChangeDisplay,
        isRestore: this.isUserRemoveSelectedOptionRestore,
      };
      try {
        console.log(param);
        if (this.isUserRemoveSelectedOptionDelete) {
          await apiClient.delete('/userctls/', {
            data: param,
            headers: {Authorization: `Bearer ${token}`},
          });
        } else {
          await apiClient.put('/userctls/', param, {
            headers: {Authorization: `Bearer ${token}`},
          });
        }
        const ope =
          this.isUserRemoveSelectedOptionDelete ||
          this.isUserRemoveSelectedOptionChangeDisplay
            ? `削除`
            : `復旧`;
        this.snackbarMessage = `${this.traineeLabel}${this.removeUsers.length}人の${ope}に成功しました`;
        this.snackbarColor = 'success';
        this.snackbarTimeout = 3000;
        this.snackbar = true;
        this.removeUsers = []; // 一覧 check box を 初期化
      } catch (err) {
        console.log(err);
      }
    },
    async userRemoveOptionChange(value: UserRemoveOptionValue) {
      const token = await this.user?.getIdToken();
      try {
        this.UserListItems.length = 0;
        const {data} = await apiClient.get<Array<UserListItem>>('/userctls/', {
          headers: {Authorization: `Bearer ${token}`},
        });
        this.UserListItems = data.filter((user: UserListItem) => {
          if (
            value == UserRemoveOptionValue.ChangeDisplay ||
            value == UserRemoveOptionValue.Restore
          ) {
            return user.isRemoved && !user.isNotDisplay;
          }
          return !user.isRemoved;
        });
      } catch (err) {
        console.log(err);
      }
      this.removeUsers = []; // 一覧 check box を 初期化
      this.userRemoveFlage = false; // 同意する check box を 初期化
    },
    async useradd(): Promise<void> {
      console.log('user add');

      (this.$refs.userAddForm as VForm).validate();

      if (!this.verify) {
        return;
      }
      this.userAddDialog = false;
      const token = await this.user?.getIdToken();
      const param = {
        familyname: this.userAdd.familyName,
        firstname: this.userAdd.firstName,
        jfamilyname: this.userAdd.jfamilyName,
        jfirstname: this.userAdd.jfirstName,
      };

      try {
        console.log(param);
        const {data} = await apiClient.post('/userctls/', param, {
          headers: {Authorization: `Bearer ${token}`},
        });
        const order = data.order;
        if (order.previos == order.current) {
          this.snackbarMessage = `${this.traineeLabel}を追加しました`;
          this.snackbarColor = 'success';
          this.snackbarTimeout = 3000;
        } else {
          this.snackbarMessage = `登録人数が60名以上になりました。<br>効率性の観点から使用台数を<b>1台当たり60名程度</b>を推奨しています。<br>VR購入の際は、らくらく監査システムのお問い合わせからご連絡下さい。`;
          this.snackbarColor = 'yellow lighten-1 black--text';
          this.snackbarTimeout = 15000;
        }
        this.userAdd = {
          familyName: '',
          firstName: '',
          jfamilyName: '',
          jfirstName: '',
        };
        this.snackbar = true;
        console.log(data);
      } catch (err) {
        console.log(err);
      }
    },
    async logout(): Promise<void> {
      await this.$store.dispatch('logout');
      this.targetYears = [];
      this.val = '';
    },
    jump(jumpPath: string): void {
      this.$router.push(jumpPath).catch(err => {
        console.log(err);
      });
    },
    info(): void {
      console.log('info');
      this.infoDialog = true;
    },
    isNoSubGroup(year: number): boolean {
      return this.noSubGroupStartYear != 0 && year >= this.noSubGroupStartYear;
    },
    async getManualURL(
      token: string,
      prefix: string,
      scope: string,
      fileType: string
    ): Promise<string> {
      let url = '';
      try {
        const {data} = await apiClient.get<Manual>(
          `/manual/download/?prefix=${prefix}&scope=${scope}&file=${fileType}`,
          {
            headers: {Authorization: `Bearer ${token}`},
          }
        );
        url = data.url;
      } catch (err) {
        console.log(err);
      }
      return url;
    },
  },

  computed: {
    getProcedurePrefix(): string {
      switch (GetScopeFromKey(this.currentScope)) {
        case 'truck': {
          return 'Procedure';
        }
        case 'forklift': {
          return 'Procedure-forklift';
        }
        default: {
          return 'Procedure';
        }
      }
    },
    isMove(): boolean {
      return (
        this.userMoveFlage &&
        this.toBranchOffice !== '' &&
        this.traineeID !== ''
      );
    },
    branchOfficeList(): (string | undefined)[] {
      var scope = GetScopeFromKey(this.currentScope);
      const current: GroupRes[] = this.companyList.filter(
        (b: GroupRes) => b.companyID == this.current
      );
      if (current.length == 0) {
        return undefined;
      }
      const fiscalStartMonthDate = current[0].fiscalStartMonthDate;

      return this.companyList
        .filter(
          (branchOffice: GroupRes) =>
            branchOffice.companyID !== this.current &&
            scope === branchOffice.scope &&
            branchOffice.fiscalStartMonthDate == fiscalStartMonthDate
        )
        .map(branchOffice =>
          branchOffice.companyJName
            ? branchOffice.companyJName
            : branchOffice.companyName
        );
    },
    version(): string {
      const version = process.env.VUE_APP_VERSION;
      return version;
    },
    colorFromScope(): string {
      switch (this.currentScope) {
        case 'apis.wacwac-audit-dev.com/truck':
          return 'indigo';
        case 'apis.wacwac-audit-dev.com/forklift':
          return 'teal';
        default:
          return 'grey';
      }
    },
    name(): void {
      return this.$store.state.accountName;
    },
    currentMode(): string {
      return this.$store.state.mode;
    },
    histList(): HistoryItem {
      return historyList;
    },
    // 12項目/ヒヤリハット 区別 有り
    menuList(): Item[] {
      const vItems = this.targetYears
        .filter(year => {
          if (this.isNoSubGroup(year.y)) {
            return false;
          } else if (
            GetScopeFromKey(this.currentScope) === 'forklift' &&
            year.y >= 2022
          ) {
            return true;
          } else if (GetScopeFromKey(this.currentScope) === 'truck') {
            return true;
          }
          return false;
        })
        .map(year => {
          return createTargetYearMenue(year.y, this.targetYear);
        });
      return vItems;
    },
    // 12項目/ヒヤリハット 区別 無し
    menuListForNoSubGroup(): Item[] {
      const vItems = this.targetYears
        .filter(year => {
          if (this.isNoSubGroup(year.y)) {
            return true;
          }
          return false;
        })
        .map(year => {
          return createTargetYearMenue(year.y, this.targetYear);
        });
      return vItems;
    },
    isNoSubGroupTargetYear: function (): boolean {
      return this.isNoSubGroup(this.targetYear);
    },
    traineeLabel(): string {
      switch (GetScopeFromKey(this.currentScope)) {
        case 'truck': {
          return 'ドライバー';
        }
        case 'forklift': {
          return '受講者';
        }
        default: {
          return 'ドライバー';
        }
      }
    },
    getMaxBranchOfficeCurrentYear(): string {
      return this.companyList
        .reduce(
          (max: number, bo: GroupRes) =>
            bo.currentYear > max ? bo.currentYear : max,
          0
        )
        .toString();
    },
    getBranchOfficeScopes(): string[] {
      const s: string[] = this.companyList.map((bo: GroupRes) => bo.scope);
      return [...new Set(s)]; // 重複を排除
    },
    selectedBranchOffice(): boolean {
      return this.val != '';
    },
    isAllRemoveUsersSelected() {
      return (
        this.UserListItems.length === this.removeUsers.length &&
        this.isUserRemoveSelectedOptionDelete
      );
    },
    isUserRemoveSelectedOptionDelete() {
      return this.userRemoveSelectedOption == UserRemoveOptionValue.Default;
    },
    isUserRemoveSelectedOptionChangeDisplay() {
      return (
        this.userRemoveSelectedOption == UserRemoveOptionValue.ChangeDisplay
      );
    },
    isUserRemoveSelectedOptionRestore() {
      return this.userRemoveSelectedOption == UserRemoveOptionValue.Restore;
    },
    isBranchOfficeView(): boolean {
      return !this.isGroup || (this.isGroup && this.current !== '');
    },
    ...mapState([
      'user',
      'newsCount',
      'scope',
      'currentScope',
      'current',
      'noSubGroupStartYear',
    ]),
    ...mapGetters(['isLogin']),
  },

  watch: {
    async user(nval, oval) {
      if (nval && !oval) {
        this.$store.commit('CLEAR_CURRENT');
        this.$store.commit('CLEAR_CURRENT_NAME');
        this.$store.commit('CLEAR_SAME_GROUP_BRANCH_OFFICE_LIST');
        console.log('try init');
        const token = await nval.getIdToken();
        await this.init(token);
      }
    },
  },
  data: (): Data => ({
    company: '',
    year: moment().year(),
    targetYear: 0,
    targetYears: [],
    infoSnackMessageColor: '',
    infoSnackMessage: '',
    infoVerify: false,
    infoSnack: false,
    infoContext: {user: '', summary: '', detail: '', phone: '', email: ''},
    infoDialog: false,
    isNew: false,
    isGroup: false,
    companyList: [],
    val: '',
    id: -1,
    drawer: false,
    model: [1, 2],
    userAddDialog: false,
    userRemoveDialog: false,
    userRemoveSelectedOption: UserRemoveOptionValue.Default,
    userRemoveOptions: [] as userRemoveOption[],
    removeUsers: [],
    userRemoveFlage: false,
    userMoveDialog: false,
    userMoveFlage: false,
    toBranchOffice: '',
    traineeID: '',
    userAdd: {
      familyName: '',
      firstName: '',
      jfamilyName: '',
      jfirstName: '',
    },
    snackbar: false,
    snackbarMessage: '',
    snackbarColor: '',
    snackbarTimeout: 3000,
    verify: false,
    UserListItems: [] as Array<UserListItem>,
    traineeName: '',
    targetBranchOfficeName: '',
    managementPdfManualURL: '',
    managementExcelManualURL: '',
    operationSystemManualURL: '',
    operationVRManualURL: '',
  }),
});
